import {GraphicUndersampling} from '../../enum/graphic-undersampling.enum';
import {GraphicGrouping} from '../../enum/graphic-grouping.enum';
import {Location} from '../../types/location.type';

export class State {
  idProject?: number;
  showEvents?: boolean;
  showOffset?: boolean;
  underSampling?: GraphicUndersampling;
  datePickerStart?: string;
  datePickerEnd?: string;
  smartOffsetModeIsChecked?: boolean;
  smartOffsetModeIsDisabled?: boolean;
  switchSmartOffsetsNotification?: 'open' | 'close';
  reloadChart?: boolean;
  informUser?: string;
  smartOffsetStateInfo?: string;
  locationsFromServer?: Location.serverSide[];
  locations?: Location.clientSide[];
  showThermalCorrection?: boolean;
  locationSelected?: number[];
  dataGroupingPeriod?: GraphicGrouping;
  timeZone?: number;
}
